var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search",on:{"click":_vm.toSearch}},[_c('Icon',{staticClass:"icon",attrs:{"color":"#fff","name":"search","size":"20"}}),_c('div',{staticClass:"input"},[_vm._v("搜索")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }